var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"4","sm":"3","md":"2","lg":"1","xl":"1"}},[_c('div',{staticStyle:{"width":"130px"}},[_c('v-img',{attrs:{"contain":true,"src":_vm.src}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }